import { GENERAL_PRESET } from '@/services/constants/report';

export default {
  route: {
    type: '',
    name: '',
  },
  showFilters: false,
  showSearch: false,
  activePreset: window.localStorage.getItem('activePreset')  || GENERAL_PRESET,
  presets: []
}
